const angular = require('angular');
const moment = require('moment');
const app = angular.module('learn-directives');
/**
 * Defines the content scroll to top button
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.directive('viewActions', [function () {
    return {
        restrict: 'E',
        replace: true,
        scope: {
            surveyOffset: '=?',
            userViewFunct: '=?',
            userEditFunct: '=?',
            userEditShow: '=?'
        },
        template: require('../../templates/directives/view-actions.html'),
        controller: ['$scope', function () {
        }]
    };
}]);
